import type { RouteRecordRaw } from 'vue-router'
import { prefixRoutes, route } from '@/router/utils'
import type { Options } from '@/router'
import { i18n } from '@/i18n'
import { accessPermission } from '@m/user/permissions'

const PROFILE_PREFIX = 'cabinet:clients'
const p = (name: string) => PROFILE_PREFIX + ':' + name

export const CREATE_CLIENT_VIEW_NAME = p('create-view')
export const CLIENTS_CATALOG_VIEW_NAME = p('catalog-view')
export const CLIENT_DETAILS_VIEW_NAME = p('details-view')

const CreateClientView = () => import('./views/CreateClient.vue')
const ClientsCatalogView = () => import('./views/ClientsCatalog.vue')
const ClientDetailsView = () => import('./views/ClientDetails.vue')

const BASE_MODEL_NAME = 'clients/'

export function createRoutes(options: Options): RouteRecordRaw[] {
  const { t: $t } = i18n.global

  return [
    route(
      'create/',
      CreateClientView,
      CREATE_CLIENT_VIEW_NAME, //cabinet/clients/create-view
      {
        meta: {
          title: () => $t('Створити клієнта'),
        },
    }),
    route(
      'catalog/',
      ClientsCatalogView,
      CLIENTS_CATALOG_VIEW_NAME, //cabinet/clients/catalog
      {
        meta: {
          title: () => $t('Усі клієнти'),
        },
    }),
    route(
      'details/:uuid/',
      ClientDetailsView,
      CLIENT_DETAILS_VIEW_NAME, //cabinet/clients/details/{uuid}/
      {
        meta: {
          title: () => $t('Клієнт'),
          fallbackRouteName: CLIENTS_CATALOG_VIEW_NAME,
        },
    }),
  ]
}

export { BASE_MODEL_NAME }